export type SyncProviderType = 'outlook' | 'imanage' | 'onedrive' | 'sharepoint'

export interface SyncProvider {
  type: SyncProviderType
  name: string
  description: string
  icon: string
}

export const AVAILABLE_PROVIDERS: SyncProvider[] = [
  {
    type: 'outlook',
    name: 'Outlook',
    description: 'Sync emails from Outlook folders',
    icon: '📨'
  },
  {
    type: 'imanage',
    name: 'iManage',
    description: 'Sync documents from iManage',
    icon: '/iManage-logo.png'
  },
  {
    type: 'onedrive',
    name: 'OneDrive',
    description: 'Sync documents from a OneDrive folder',
    icon: 'onedrive'
  },
  {
    type: 'sharepoint',
    name: 'SharePoint',
    description: 'Sync documents from a SharePoint site/library',
    icon: 'sharepoint'
  }
]

export function getAvailableSyncProviders(options: {
  iManageEnabled: boolean
  oneDriveEnabled: boolean
  sharePointEnabled: boolean
}): SyncProvider[] {
  return AVAILABLE_PROVIDERS.filter((provider) => {
    if (provider.type === 'imanage') {
      return options.iManageEnabled
    }
    if (provider.type === 'onedrive') {
      return options.oneDriveEnabled
    }
    if (provider.type === 'sharepoint') {
      return options.sharePointEnabled
    }
    return true
  })
}
